import { WizardTranslations } from "./wizard-pt-br";

export const WIZARD_ES_ES: WizardTranslations = {
	common: {
		pointsOfSale: "Puntos de venta",
		saved: "Guardar",
		cancel: "Cancelar",
		typeHere: "Digite aqui",
		close: "Cerrar",
	},
	welcome: {
		title: "¡Bienvenido, <placeName>{{placeName}}</placeName>!",
		subtitle: "Elige cómo quieres configurar tu operación.",
		skipButton: "No quiero configurar ahora",
		placeIdNotFound: "ID de lugar no encontrado",
		features: {
			preConfiguredSteps: "Pasos con sugerencias preconfiguradas",
			guidedStepsWithAI: "Paso a paso guiado con ayuda de IA",
			advancedConfigurations: "Configuraciones avanzadas y personalizaciones",
			complexFeatures: "Funcionalidades más complejas",
		},
		guidedMode: {
			title: "Creación guiada (modo simplificado)",
			subtitle: "Te guiamos paso a paso",
			buttonText: "Acceder al modo simplificado",
			features: {
				basicConfigurations: "Configuraciones más básicas",
				idealForSimpleOperations: "Ideal para operaciones más simples y pequeñas",
			},
		},
		advancedMode: {
			title: "Creación avanzada",
			subtitle: "Más opciones y detalles de configuración",
			buttonText: "Acceder al modo avanzado",
			features: {
				directConfiguration: "Configuración directa en los módulos del Dashboard",
				idealForComplexOperations: "Ideal para operaciones grandes y complejas",
			},
		},
	},
	container: {
		stepIndexTitle: "Configura tu local",
		buttons: {
			back: "Volver",
			close: "Cerrar",
			next: "Siguiente",
			configureLater: "Configurar después",
			finishConfiguration: "Concluir configuraciones",
			backToStep: "Volver a la Etapa {{step}}",
		},
		finishConfirmation: {
			title: "Concluir configuraciones de la operación",
			descriptionPart1: "Estás a punto de concluir la configuración de esta operación.",
			descriptionPart2:
				"Se generará un resumen final que estará disponible para consulta en cualquier momento. Después, podrás revisar y editar cuando lo necesites.",
			cancelButton: "Cancelar",
			confirmButton: "Concluir configuraciones",
			successMessage: "¡Configuraciones guardadas con éxito!",
			continueToNextStep: {
				title: "Concluir y seguir a la próxima etapa",
				descriptionPart1: "Estás a punto de concluir esta etapa.",
				descriptionPart2:
					"Al continuar, la configuración se guardará y pasarás a la próxima etapa.",
				confirmButton: "Guardar y avanzar",
			},
		},
		closeModalConfirmation: {
			title: "¿Salir de la configuración sin guardar?",
			description:
				"Al cerrar ahora, la información configurada hasta aquí no se guardará y perderás el progreso. ¿Deseas continuar?",
			cancelButton: "Continuar configurando",
			confirmButton: "Salir sin guardar",
			fromSecondStep: {
				title: "¿Salir de la configuración simplificada?",
				descriptionIntro:
					"Este asistente ayuda a configurar tu operación de forma simplificada. Si sales ahora:",
				bullet1: "No podrás volver para continuar la configuración por aquí",
				bullet2: "La información de esta etapa se descartará",
				bullet3: "Las etapas ya completadas permanecerán guardadas",
				descriptionOutro:
					"Si sales ahora, las próximas configuraciones deberán hacerse directamente en las pantallas avanzadas del Dashboard.",
				cancelButton: "Continuar configurando",
				confirmButton: "Salir de la configuración simplificada",
			},
		},
		steps: {
			basicInformation: {
				title: "Información básica",
				subtitle: "Configura el tipo de operación",
				operationType: {
					title: "¿Cómo <highlight>comprarán</highlight> los clientes?",
					subtitle: "Elige uno o más formatos que se aplicarán a esta operación.",
					alert: {
						message: "Revisa esta etapa con calma.",
						description:
							"Al avanzar a la siguiente etapa, estas configuraciones ya no podrán editarse en este onboarding y solo podrán ajustarse en el Dashboard.",
					},
					subStepTitle: "Tipo de operación",
				},
				funcionalities: {
					title:
						"¿Qué serán las <highlight>funcionalidades</highlight> de esta operación?",
					subtitle:
						"Las funcionalidades son opciones con recursos que permiten configurar la operación de forma personalizada.",
					subStepTitle: "Funcionalidades",
					searchFunctionalities: "Buscar por funcionalidades",
					placeholderSearchFunctionalities: "Ingrese aquí la funcionalidad",
					activeLabel: "activas",
					loadingText: "Cargando funcionalidades...",
					emptySearchResults: "Ninguna funcionalidad encontrada",
				},
				review: {
					title:
						"¡Ya entendimos las <highlight>configuraciones iniciales</highlight> de la operación!",
					subtitle: "De acuerdo con tus respuestas, el sistema configurará:",
					subStepTitle: "Revisión",
					reviewTitle: "Revisa las respuestas",
					reviewSubtitle: "Podrás editarlas ahora, antes de concluir la etapa.",
					editStep: "Editar etapa",
					operationTypeLabel: "Tipo de operación",
					functionalitiesLabel: "Funcionalidades",
					notInformed: "No informado",
					selectedCount: "{{count}} seleccionada(s)",
					viewFunctionalities: "Ver funcionalidades",
				},
			},
			pointsOfSale: {
				pdvCentralName: "Punto de venta central",
				title: "Puntos de venta",
				subtitle: "Configura los locales de venta",
				pointsOfSale: {
					subStepTitle: "Puntos de venta",
					title: "¿Cuáles serán los puntos de venta de esta operación?",
					subtitle:
						"Nombra solo los puntos de venta que serán los lugares donde estarán las máquinas Zig.",
					createButton: "Crear punto de venta",
					defaultPdvName: "Nuevo punto de venta",
					totalCount: "Total de puntos de venta: <strong> {{count}} </strong>",
					aiTutorial: "Aprende cómo usar la IA para crear los puntos de venta",
					tour: {
						step1: {
							title:
								"El punto de venta es donde ocurren las ventas de tu operación a través de las máquinas Zig.",
							content:
								"Si tu operación tiene solo 1 (uno) punto de venta, simplemente continúa. Si necesitas editar o crear nuevos puntos, puedes hacerlo ahora.",
						},
						step2: {
							title: "Puedes crear los puntos de venta con ayuda de la IA",
							content:
								"Si quieres utilizar la IA, describe los nombres y cantidades deseadas, y serán generados automáticamente.",
						},
						step3: {
							title:
								"¿Quieres revisar algo? Usa el menú lateral para volver a las etapas ya completadas.",
							content:
								"Simplemente haz clic en una etapa completada para revisar las configuraciones y vuelve a la etapa actual para continuar donde lo dejaste.",
						},
					},
					aiTutorialModal: {
						step1: {
							title: "Haz clic en el <highlight>Asistente de IA</highlight>",
							description:
								"Abre el Asistente para iniciar la creación automática de tus puntos de venta.",
						},
						step2: {
							title:
								"Describe los nombres y cantidades de los <highlight>puntos de venta</highlight>",
							description:
								"Informa cuáles son los nombres y cantidades de los locales donde se realizarán las ventas con las máquinas Zig en la operación. (Ej.: 1 Bar Principal, 2 Pistas Premium, 1 Área de Cocina)",
							note: "¡Esmera en las descripciones!",
						},
						step3: {
							title: "Confirma y <highlight>genera los puntos de venta</highlight>",
							description:
								"Revisa el resumen que te mostrará la IA y haz clic en 'Generar puntos de venta' para crearlos automáticamente.",
						},
						buttons: {
							understand: "Entendido",
						},
					},
					aiAssistant: {
						panelTitle: "Asistente de IA de Zig",
						triggerBubbleTitle: "Soy tu Asistente de IA de Zig.",
						triggerBubbleSubtitle: "Te ayudo a crear los puntos de venta",
						inputPlaceholder: "Describe los puntos de venta o pregunta algo",
						generateButton: "Generar puntos de venta",
						initialMessage:
							"👋 ¡Hola! Soy tu Asistente de IA.\nEstoy aquí para ayudarte a crear los puntos de venta de tu operación.\n\n📋 Solo dime cuáles necesitas (nombres y cantidades).\nYo reviso todo contigo y, con tu confirmación, los genero automáticamente.\n\n💬 ¿Empezamos? ¿Qué puntos de venta deseas crear?",
						summaryIntro: "¡Perfecto! Aquí está el resumen de lo que describiste:",
						summaryConfirmation:
							"Si todo está correcto, solo haz clic abajo para generar los puntos de venta.",
						loadingMessage: "Creando...",
						successMessage: "🎉 ¡Listo! Los puntos de venta fueron creados con éxito.",
						successFollowUp:
							"Si quieres agregar más puntos de venta, solo envíame los nombres y cantidades nuevamente.",
						onlyCreateError:
							"😅 Lo siento, aquí solo puedo crear nuevos puntos de venta. Si necesitas editar o eliminar alguno existente, puedes hacerlo directamente en la pantalla.",
					},
				},
				sectors: {
					subStepTitle: "Sectores",
					title:
						"¿Deseas organizar los puntos de venta en <highlight>sectores</highlight>?",
					subtitle:
						"Define si prefieres estructurar tus puntos de venta en sectores o mantener cada uno por separado.",
					options: {
						withoutSectors: {
							title: "Mantener los puntos de venta independientes (sin sectores)",
							subtitle:
								"Los puntos de venta serán independientes, sin agrupación por sector.",
						},
						withSectors: {
							title: "Organizar los puntos de venta por sectores",
							subtitle:
								"Los puntos de venta se agruparán dentro de los sectores que definas.",
						},
					},
					placeholder: {
						message: "La funcionalidad de sectores será implementada en breve.",
					},
					creation: {
						title: "Agrupa todos los puntos de venta en sectores",
						subtitle: "Todos los puntos de venta deberán pertenecer a algún sector.",
						createButton: "Crear nuevo Sector",
						emptyTitle: "Aún no hay nada por aquí",
						emptySubtitle: "Agrupa puntos de venta en sectores",
						unlinkedCount: "{{count}} Puntos de venta por agrupar",
						tour: {
							title: "Crea el primer sector",
							content:
								"Haz clic en el botón 'Crear nuevo sector' para empezar a organizar tus puntos de venta.",
							understood: "Entendido",
						},
						deleteConfirmTitle: "¿Eliminar sector?",
						deleteConfirmSubtitle:
							"Este sector se eliminará. Los puntos de venta podrán asignarse a otro sector.",
					},
					creationDrawer: {
						createTitle: "Crear nuevo Sector",
						editTitle: "Editar Sector",
						nameLabel: "Nombre",
						namePlaceholder: "Introduce el nombre del sector",
						nameRequired: "Campo obligatorio",
						pointsOfSaleLabel: "Puntos de venta del Sector",
						pointsOfSalePlaceholder: "Selecciona los puntos de venta",
						pointsOfSaleRequired: "Campo obligatorio",
						createButton: "Crear nuevo Sector",
						saveButton: "Guardar",
					},
				},
				review: {
					subStepTitle: "Revisión",
					title: "Revisa la configuración de puntos de venta",
					subtitle: "Verifica los puntos de venta configurados antes de continuar",
					reviewTitle: "Revisa las respuestas",
					reviewSubtitle: "Podrás editarlas ahora, antes de concluir la etapa.",
					editStep: "Editar etapa",
					editPointsOfSale: "Puntos de venta",
					editSectors: "Sectores",
					pointsOfSaleLabel: "Puntos de venta",
					notInformed: "No informado",
				},
				pdvCreateNewPdvDrawer: {
					title: "Este nombre de punto de venta ya existe",
					subtitle:
						"Un punto de venta con este nombre ya existe. Para continuar, elige un nombre diferente para evitar duplicidad.",
					newPdvDrawerTitle: "Nombre del punto de venta",
					createButton: "Crear punto de venta",
					nameRequired: "El nombre del punto de venta es obligatorio",
				},
			},
			menu: {
				title: "Carta",
				subtitle: "Configura los productos",
				organization: {
					title:
						"¿Las <highlight>ventas serán diferentes</highlight> según el punto de venta?",
					subtitle:
						"Define si los puntos de venta compartirán los mismos productos y precios o si habrá diferencias entre ellos.",
					subStepTitle: "Organización",
					yes: {
						title: "SÍ",
						subtitle: "Cada punto de venta tendrá sus propios productos y precios.",
						example:
							"Ejemplo: Cada punto de venta tiene ventas propias con productos diferentes.",
					},
					no: {
						title: "NO",
						subtitle:
							"Todos los puntos de venta tendrán los mismos productos y los mismos precios.",
						example:
							"Ejemplo: En cualquier punto de venta las opciones de productos son idénticas.",
					},
					changeFormatModal: {
						title: "¿Desea cambiar el formato de venta de los puntos de venta?",
						description:
							"Está cambiando la forma en que se venden los productos entre los puntos de venta. Este cambio puede afectar las configuraciones actuales y puede requerir ajustes según la nueva elección. ¿Desea continuar de todos modos?",
						cancelButton: "Cancelar",
						confirmButton: "Sí, cambiar formato de venta",
					},
				},
				buildMenus: {
					title: "Crea tu <highlight>carta</highlight>",
					subtitle: "Importa productos con fotos, hojas de cálculo o PDFs.",
					subStepTitle: "Crear carta",
					templateFileName: "plantilla_productos_menu",
					buttons: {
						templateSpreadsheet: "Hoja de cálculo modelo",
						createCategory: "Crear categoría",
						addManually: "Añadir manualmente",
					},
					tour: {
						locale: {
							back: "Volver",
							next: "Siguiente",
							close: "Entendido",
						},
						steps: {
							upload: {
								title: "Comienza subiendo un archivo con los productos.",
								content:
									"Puedes añadir una foto, hoja de cálculo o PDF con los productos que deseas incluir en esta carta. La IA leerá el archivo y registrará automáticamente los artículos por ti.",
							},
							manual: {
								title: "O, si lo prefieres, añade los productos manualmente.",
								content:
									"Si lo deseas, puedes crear categorías y añadir productos manualmente sin usar un archivo.",
							},
						},
					},
					addProductDrawer: {
						title: "Añadir producto",
						titleEdit: "Editar producto",
						labels: {
							name: "Nombre del producto",
							value: "Precio",
							category: "Categoría del producto",
						},
						placeholders: {
							name: "Escribe aquí el nombre del producto",
							value: "00,00",
							category: "Selecciona",
						},
						errors: {
							nameRequired: "El nombre del producto es obligatorio",
							nameDuplicated: "Ya existe un producto con este nombre",
							valueRequired: "El precio del producto es obligatorio",
							categoryRequired: "La categoría es obligatoria",
						},
						buttons: {
							cancel: "Cancelar",
							add: "Añadir producto",
							save: "Guardar",
						},
						createCategoryOption: "Crear categoría",
					},
					createCategoryModal: {
						title: "Crear categoría",
						label: "Nombre de la categoría",
						placeholder: "Escribe aquí el nombre de la categoría",
						errors: {
							nameRequired: "El nombre de la categoría es obligatorio",
							nameDuplicated: "Ya existe una categoría con este nombre",
						},
						buttons: {
							cancel: "Cancelar",
							create: "Crear categoría",
						},
					},
					removeCategory: {
						title: "Eliminar categoría",
						description:
							"Al eliminar esta categoría, todos los productos vinculados a ella también serán eliminados. ¿Deseas continuar?",
						confirmButton: "Eliminar categoría",
					},
					removeProduct: {
						title: "Eliminar producto",
						description:
							"Este producto será eliminado de la carta y ya no podrá ser vendido en los puntos de venta. ¿Deseas confirmar la eliminación?",
						confirmButton: "Eliminar producto",
					},
				},
				linkProducts: {
					title: "Vincula los <highlight>productos</highlight> a los puntos de venta",
					subtitle:
						"Las cartas y productos se venderán en el punto de venta al que estén vinculados",
					subStepTitle: "Vincular productos",
					noProductsLinked: "¡No hay productos vinculados!",
					productsCount: "{{count}} productos",
					productsCount_one: "{{count}} producto",
					linkProductsButton: "Vincular productos",
					viewProductsLink: "Ver productos",
					incompleteModal: {
						title: "Algunos puntos de venta están incompletos",
						description:
							"Algunos puntos de venta no tienen cartas ni productos vinculados. Puedes vincular ahora o continuar y editar después.",
						continueButton: "Continuar y editar después",
						editButton: "Editar ahora",
					},
					tour: {
						locale: {
							close: "Entendido",
						},
						step: {
							title: "Define lo que cada punto de venta venderá.",
							content:
								"Selecciona las cartas que tendrá este punto. También puedes desactivar/activar productos específicos, dejando solo lo que se venderá en él.",
						},
					},
					drawer: {
						editTitle: "Selecciona cartas para este punto de venta",
						editSubtitle:
							"Los productos de estas cartas se vincularán a este punto. Puedes desactivar productos específicos si lo deseas.",
						viewTitle: "Productos vinculados",
						viewSubtitle:
							"Revisa los productos de este punto de venta y edita los vínculos si lo deseas.",
						selectAllLabel: "Seleccionar todos los productos de {{categoryName}}",
						labels: {
							menus: "Cartas",
							searchProduct: "Buscar por producto",
							searchCategory: "Buscar por categoría del producto",
						},
						placeholders: {
							menus: "Selecciona",
						},
						buttons: {
							cancel: "Cancelar",
							link: "Vincular productos",
							edit: "Editar",
							close: "Cerrar",
						},
						empty: {
							title: "Aún no hay nada aquí",
							subtitle: "Vincula qué cartas tendrá este punto de venta.",
						},
						noResultsFound: {
							title: "Ningún resultado encontrado",
							subtitle: "Intenta buscar con otro término.",
						},
					},
				},
				review: {
					title: "Revisa la <highlight>configuración de la carta</highlight>",
					subtitle: "Comprueba que toda la información sea correcta antes de continuar.",
					subStepTitle: "Revisión",
					pendingTitle: "Etapa 3: <highlight>configuraciones pendientes</highlight>",
					pendingSubtitle: "Decidiste configurar esta etapa después.",
					reviewTitle: "Revisa las respuestas",
					reviewSubtitle: "Podrás editarlas ahora, antes de concluir la etapa.",
					editStep: "Editar etapa",
				},
			},
			employees: {
				title: "Empleados",
				subtitle: "Configura el equipo de la operación",
				rolesAndPermissions: {
					title:
						"¿Quién trabajará usando las <highlight>máquinas de fichas</highlight> en la operación?",
					subtitle:
						"Define los puestos y cantidades de quienes venderán fichas con las máquinas en la operación.",
					subStepTitle: "Puestos y permisos",
					header: "Puestos y permisos",
					totalEmployees: "Total de empleados:",
					createRole: "Crear nuevo puesto",
					roleDrawer: {
						title: "Crear puesto",
						roleNameLabel: "Nombre del puesto",
						selectStandardRole: "Selecciona un puesto estándar ya existente",
						selectStandardRolePlaceholder: "Selecciona un puesto",
						defaultPermissionsTab: "Permisos estándar",
						otherPermissionsTab: "Otros permisos",
						createButton: "Crear puesto",
						duplicateNameError: "Ya existe un puesto con ese nombre",
						editTitle: "Editar puesto",
						duplicateTitle: "Duplicar puesto",
						viewTitle: "Ver permisos",
						editRoleButton: "Editar puesto",
						confirmButton: "Confirmar",
						searchPermissionsPlaceholder: "Buscar un permiso",
						confirmClose: {
							title: "¿Descartar cambios?",
							subtitle:
								"Tienes cambios sin guardar. ¿Estás seguro de que deseas cerrar sin guardar?",
							confirm: "Descartar",
							cancel: "Seguir editando",
						},
					},
					confirmDelete: {
						title: "Eliminar puesto con empleados vinculados",
						subtitle:
							"Este puesto tiene {{count}} empleado(s) vinculado(s). ¿Desea eliminarlo de todas formas?",
						confirm: "Eliminar puesto",
						cancel: "Cancelar",
					},
					tour: {
						locale: {
							back: "Volver",
							next: "Siguiente",
							close: "Entendido",
						},
						step1: {
							title: "Estos puestos son sugerencias para tu operación.",
							content:
								"Puedes editarlos o eliminarlos según lo desees. Si no quieres que un puesto exista en la operación, elimínalo. De lo contrario, se creará incluso si la cantidad es cero.",
						},
						step2: {
							title: "Define cuántas personas tendrán cada puesto",
							content:
								"Usa el contador para indicar cuántas personas actuarán en cada función. Solo los puestos con cantidad definida tendrán logins generados automáticamente.",
						},
						step3: {
							title: "Crea puestos personalizados",
							content:
								"Si necesitas un puesto diferente a los sugeridos, haz clic en Crear nuevo puesto para agregar funciones específicas y definir permisos personalizados.",
						},
					},
				},
				linkEmployees: {
					title: "Vincular empleados",
					subtitle: "Asocia los empleados a cada punto de venta.",
					subStepTitle: "Vincular empleados",
					tour: {
						locale: {
							back: "Volver",
							next: "Siguiente",
							close: "Entendido",
						},
						step1: {
							title: "Vincula los empleados a los puntos de venta",
							content:
								"Los empleados deben estar vinculados a los puntos de venta para usar los terminales y registrar las ventas. Puedes definir si todos los del mismo puesto trabajarán en los mismos puntos de venta o si deseas distribuirlos individualmente.",
						},
						step2: {
							title: "Distribuye manualmente, si prefieres",
							content:
								"Activa la opción Distribuir manualmente para definir dónde trabajará cada empleado. Así podrás elegir a qué puntos de venta tendrá acceso cada empleado y verlo de forma individual.",
						},
					},
				},
				review: {
					title: "¡<highlight>Empleados y puestos</highlight> configurados!",
					subtitle: "Los empleados y puestos de la operación ya están configurados.",
					subStepTitle: "Revisión",
					pendingTitle: "Etapa 4: <highlight>configuraciones pendientes</highlight>",
					pendingSubtitle: "Decidiste configurar esta etapa después.",
					reviewTitle: "Revisa tus respuestas",
					reviewSubtitle: "Puedes editarlas ahora, antes de completar la etapa.",
					editStep: "Editar etapa",
					reviewAlertTitle: "Revisa esta etapa con calma.",
					reviewAlert:
						"Al avanzar, estas configuraciones no podrán editarse aquí y solo podrán ajustarse directamente en los módulos del Dashboard.",
					notConfigured: "Etapa no configurada",
					pendingEmptySubtitle: "Aún no has configurado los empleados de esta operación.",
				},
			},
		},
		operationTypes: {
			token: {
				label: "Ficha",
				description: "El cliente cambia ficha por producto",
			},
			cashlessPrepaid: {
				label: "Cashless (prepago)",
				description: "El cliente carga crédito en una tarjeta",
			},
			cashlessPostpaid: {
				label: "Cashless (pospago)",
				description: "El cliente paga en una tarjeta después del consumo",
			},
			directSale: {
				label: "Venta directa en barra",
				description: "El cliente paga el producto directamente",
			},
			tables: {
				label: "Mesas",
				description: "El cliente realiza el pedido a los camareros",
			},
		},
		summary: {
			title: "¡Resumen de la configuración de <placeName>{{placeName}}</placeName>!",
			subtitle:
				"Edita respuestas, vuelve etapas o accede a configuraciones avanzadas en cualquier momento.",
			editStep: "Editar etapa",
			operationType: "Tipo de operación",
			functionalities: "Funcionalidades",
			viewFunctionalities: "Ver funcionalidades",
			advancedConfigurations: "Configuraciones avanzadas de Funcionalidades",
			notInformed: "No informado",
			selectedCount: "{{count}} seleccionada(s)",
			pendingAction: "Acción pendiente",
			loading: "Cargando configuraciones...",
			placeIdNotFound: "ID de lugar no encontrado",
			errorLoading: "Error al cargar datos",
			menuContent: {
				manageLink: "Configuración avanzada de Menú",
				empty: {
					title: "Aún no hay nada aquí",
					subTitle: "Configura esta etapa para ver el resumen aquí.",
				},
				advancedConfig: "Configuración avanzada",
			},
			employeesContent: {
				manageLink: "Configuración avanzada de Equipos y Roles",
			},
			stepEmpty: {
				title: "Aún no hay nada aquí",
				subTitle:
					"El asistente de configuración ya no está disponible, pero puedes completar esta configuración en el Dashboard.",
				buttonLabel: "Configuración avanzada",
			},
		},
	},
	components: {
		pdvCard: {
			menu: {
				edit: "Editar",
				remove: "Eliminar",
				ariaLabel: "Menú de opciones",
			},
			buttons: {
				cancel: "Cancelar",
				save: "Guardar",
			},
		},
		productCard: {
			menu: {
				edit: "Editar",
				remove: "Eliminar",
				ariaLabel: "Menú de opciones",
			},
		},
		positionCard: {
			menu: {
				viewPermissions: "Ver permisos",
				edit: "Editar",
				duplicate: "Duplicar",
				remove: "Eliminar",
				ariaLabel: "Menú de opciones",
			},
			decrementLabel: "Disminuir cantidad",
			incrementLabel: "Aumentar cantidad",
		},
		menuCard: {
			productsCount: "{{count}} productos",
		},
		empty: {
			title: "No hay datos para exibir",
			description: "Parece que no hay datos para exibir.",
			button: "Agregar nuevo item",
		},
		attachmentsFile: {
			loadingText: "Espere mientras enviamos el archivo...",
			dragText: "Arrastre y suelte el archivo",
			clickText: "o haga clic para seleccionar",
			fileTypeText: "Tipo de archivo {{fileType}} hasta {{fileSize}}.",
			maxSizeExceeded: "El tamaño del archivo excede el límite permitido.",
		},
		modalSelectImage: {
			productImage: "Editar imagen",
			setTagInput: "busque el producto usando palabras clave",
			notInformed: "Nombre no informado",
			confirm: "Confirmar",
			selectFrom: "Seleccione imagen de su ",
			computer: "computador",
			addImage: "Agregar imagen",
			typeOfFile: "Tipo de archivo .jpg, .jpeg, .png hasta 5MB",
			errorCreatingImageUrl: "Error al crear la URL de la imagen",
		},
		employeePdvLink: {
			manualDistribution: "Distribuir manualmente",
			description:
				"Elija para qué puntos de venta todos los <strong>{{count}} {{roleName}}</strong> van a trabajar",
			selectedCount: "{{count}} Seleccionados",
			selectPointsOfSale: "Seleccione los puntos de venta",
			noEmployees: "No se han creado empleados para este cargo.",
			noEmployeesMessage:
				"Define la cantidad de personas en este cargo para habilitar la distribución por punto de venta.",
		},
		employeeRoleTable: {
			columnOperator: "OPERADOR",
			columnLogin: "LOGIN",
			columnPassword: "CONTRASEÑA",
			columnPdv: "PUNTOS DE VENTA VINCULADOS",
			linkedTo: "Vinculados a",
			employeesCount: "{{count}} empleados",
			viewPermissions: "Ver permisos",
			notInformed: "No informado",
			noEmployees: "Sin funcionarios aún",
		},
		menuHeader: {
			linkedTo: "Vinculado a:",
			noLinkedPdv: "Sin punto de venta vinculado",
			noLinkedMenu: "Sin cardápio vinculado",
			notConfigured: "No configurado",
			productsCount: "{{count}} PRODUCTOS",
		},
	},
};
